import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import dayjs from 'dayjs';
import QRCode from 'qrcode.react';
import qs from 'query-string';

import { CONTEXT, STORE_3G_HOST, STORE_3G_CHANNEL } from '../../config';
import { setIframeVisible } from '../../actions/layout';
import ApkButton from '../../components/Button/Button';
import Rate from '../../components/Rate/Rate';
import { logging, logPostInfo } from '../../actions/log';
import styles from './SoftDetailMore.module.less';
import { logNative, getUrlByTargetContent } from '../../utils/utils';
// import { addCollectSpecial, deleteCollectSpecial } from '../../actions/collection';
// import { getAAppDetails } from '../../actions/adetail';
import Btn from '../../components/Btn/Btn';
import { setFasterProduct } from '../../actions/layout';
import useLoginStatus, { handleLogin } from '../../utils/hooks/useLoginStatus';
import config from './config';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ softDetails, match, updateSoftDetails, handleDowm }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const [isCollect, setIsCollect] = useState(false);
  const loginStatus = useLoginStatus();
  const init = useRef(null);
  const search = qs.parse(location?.search) || {};

  const onDetailsActivity = useCallback((bannerInfo, flag) => {
    dispatch(
      logging({
        category: 'C',
        action: flag === 'rank' ? 'AppDetail_Rank' : 'AppDetail_Activity',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: match.params.pn,
          packageName: match.params.pn,
          versionCode: match.params.vc,
          softType: '1',
          targetContent: bannerInfo.targetContent,
        },
        param3: softDetails.bizInfo,
      }),
    );
    if (
      bannerInfo.targetType === '1' ||
      bannerInfo.targetType === '3' ||
      bannerInfo.targetType === '11'
    ) {
      dispatch(
        logPostInfo({
          source_p: `AppDetail||${flag === 'rank' ? 'AppDetail_Rank' : 'AppDetail_Activity'}`,
          source_pp: logInfoData.source_p,
        }),
      );
      let url = `${CONTEXT}/`;
      if (bannerInfo.targetType && bannerInfo.targetContent) {
        url = getUrlByTargetContent(bannerInfo);
      }
      history.push(url);
    } else if (bannerInfo.targetType === '2') {
      if (bannerInfo.targetUrl) {
        window.open(bannerInfo.targetUrl);
      } else if (bannerInfo.targetContent) {
        if (typeof bannerInfo.targetContent === 'string') {
          try {
            const targetContent = JSON.parse(bannerInfo.targetContent) || {};
            window.open(targetContent.targetUrl);
          } catch (error) {}
        } else if (bannerInfo.targetContent.targetUrl) {
          window.open(bannerInfo.targetContent.targetUrl);
        }
      }
    } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
      let targetContent = {};
      try {
        targetContent = JSON.parse(bannerInfo.targetContent);
      } catch (error) {
        logNative(`分析商城URL JSON解析错误:${error}`, error);
      }
      if (targetContent && targetContent.url) {
        dispatch(
          setIframeVisible({
            visible: true,
            url: targetContent.url,
            source: 'softDetail',
          }),
        );
      }
    }
  });

  // 点击查看二维码
  const handleShowCloseQRcode = useCallback(
    ev => {
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_QRCode',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: match.params.pn,
            packageName: match.params.pn,
            versionCode: match.params.vc,
            softType: '1',
          },
          param3: match.params.bizInfo,
        }),
      );
    },
    [dispatch, logInfoData, match],
  );

  const handleCollect = async () => {
    setIsCollect(true);
    if (!loginStatus) {
      // 调用登陆
      handleLogin(); // 未登录 调用登录弹窗
      return;
    }
    setIsCollect(false);
    if (!softDetails.hasCollect) {
      try {
        const data = await config.addCollectSpecial(
          {
            targetId: softDetails.packageName,
            targetType: 'android',
          },
          softDetails,
        );
        updateSoftDetails(data);
      } catch (err) {
        //
      }
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_Collect',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softDetails.packageName,
            softType: '1',
          },
          param3: softDetails.bizInfo,
        }),
      );
    } else {
      try {
        const data = await config.deleteCollectSpecial(
          {
            targetId: softDetails.packageName,
            targetType: 'android',
          },
          softDetails,
        );
        updateSoftDetails(data);
      } catch (err) {}
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_Collect_Cancel',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softDetails.packageName,
            softType: '1',
          },
          param3: softDetails.bizInfo,
        }),
      );
    }
  };

  useEffect(() => {
    if (isCollect && isCollect) {
      handleCollect();
    }
  }, [loginStatus, isCollect, softDetails]);

  const handleFasterProduct = () => {
    dispatch(
      setFasterProduct({
        soft: { ...softDetails, bizInfo: match.params.bizInfo },
        info: { isFasterProduct: true },
        logInfo: { source: 'AppDetail' },
      }),
    );

    dispatch(
      logging({
        category: 'C',
        action: 'Accelerate',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: softDetails.packageName,
          accelerate: softDetails.appRecommend && softDetails.appRecommend.softId,
          softType: '1',
        },
        param3: softDetails.bizInfo,
      }),
    );
  };

  const handleDownload = () => {
    handleDowm(true);
  };

  return (
    <div
      className={`${styles.detail_infos} ${softDetails &&
        softDetails.cover &&
        styles.detail_infos_cover}`}
    >
      <div className={styles.detail}>
        <div className={styles.detail_logo}>
          <img className={styles.detail_img} src={softDetails.logoFile} />
          <div className={styles.detail_android_logo} />
        </div>
        <div className={styles.detail_info}>
          <div className={styles.detail_info_row1}>
            <div className={styles.detail_info_row1_column1}>
              <div className={styles.detail_info_row1_line1}>
                <div
                  className={styles.detail_info_title}
                  title={`${
                    softDetails.softName && softDetails.softName.length > 6
                      ? softDetails.softName
                      : ''
                  }`}
                >
                  {softDetails.softName}
                </div>
                {softDetails.score > 70 && (
                  <div className={styles.detail_info_score}>
                    <Rate score={(softDetails.score / 20).toFixed(1)} />
                  </div>
                )}
              </div>
              {softDetails.detailsTag && (
                <div className={styles.detail_info_row1_line2}>
                  {softDetails.detailsTag.map((tag, i) => (
                    <div className={styles.detail_info_tag} key={i} title={tag.tips}>
                      <img className={styles.detail_info_tag_icon} src={tag.icon} alt="i" />
                      <span className={styles.detail_info_tag_text}>{tag.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className={styles.detail_info_row1_column2}>
              <div className={styles.detail_info_row1_column2_1}>
                <div
                  className={classNames(styles.detail_qrcode_mini)}
                  onMouseOver={e => handleShowCloseQRcode(e)}
                >
                  <div className={styles.detail_qrcode}>
                    <div className={styles.detail_qrcode_text}>可使用安卓手机扫描下载</div>
                    <QRCode
                      className={styles.qrcode_image}
                      size={105}
                      level="Q"
                      value={`${STORE_3G_HOST}/redsea/${softDetails.packageName}?ch=${STORE_3G_CHANNEL}`}
                    />
                  </div>
                </div>
                <div className={classNames(styles.collect)} onClick={handleCollect} title="收藏">
                  <i
                    className={classNames(
                      'iconfont',
                      softDetails.hasCollect ? 'icon-collected_soft' : 'icon-collect_soft',
                    )}
                  />
                </div>
              </div>
              {softDetails && softDetails.appRecommend && (
                <Btn className={styles.fasterProductBtn} handleClick={handleFasterProduct}>
                  <div className={styles.fasterProductIcon} />
                  <span className={styles.fasterProductBtnText}>加速</span>
                </Btn>
              )}
              <div onClick={handleDownload}>
                <ApkButton
                  soft={{ ...softDetails, bizInfo: match.params.bizInfo }}
                  info={{
                    className: styles.soft_btn,
                    className_busing: styles.soft_btn_busing,
                    className_open: styles.soft_button_open,
                    text: '立即安装',
                    isCompetitive: true,
                    isFasterProduct: true,
                  }}
                  logInfo={{
                    source: 'AppDetail',
                    isSearch: search?.isSearch,
                    // isSearch:
                    //   logInfoData.source_p &&
                    //   (logInfoData.source_p.indexOf('Search') > -1 ||
                    //     logInfoData.source_p.indexOf('Search_Try') > -1 ||
                    //     logInfoData.source_p.indexOf('Search_Lenovo') > -1),
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.detail_info_row2}>
            <div className={styles.detail_info_item}>
              <span className={styles.detail_info_item_value}>{softDetails.downloadCount}下载</span>
            </div>
            <div className={styles.detail_info_item}>
              <span className={styles.detail_info_item_value}>{softDetails.installFileSize}</span>
            </div>
            <div className={styles.detail_info_item}>
              <span>更新时间：</span>
              <span className={styles.detail_info_item_value}>
                {dayjs(softDetails.createdTime).format('YYYY-MM-DD')}
              </span>
            </div>
            <div className={styles.detail_info_item}>
              <span>版本号：</span>
              <span className={styles.detail_info_item_value} title={softDetails.version}>
                {softDetails.version}
              </span>
            </div>
          </div>
        </div>
      </div>
      {softDetails.classRankingDesc && (
        <div
          className={styles.detail_rank}
          onClick={() => {
            onDetailsActivity(softDetails.classRankingDesc, 'rank');
          }}
        >
          <div className={styles.detail_rank_icon}>榜单</div>
          <div className={styles.detail_rank_text}>{softDetails.classRankingDesc.targetDesc}</div>
          <div className={`iconfont icon-point_right ${styles.detail_rank_point}`} />
        </div>
      )}
      {softDetails.editorRecommend && (
        <div
          className={styles.detail_reco}
          title={softDetails.editorRecommend.length > 50 ? softDetails.editorRecommend : ''}
        >
          <span className={styles.detail_reco_name}>推荐理由：</span>
          <span>{softDetails.editorRecommend}</span>
        </div>
      )}

      {softDetails.activityList && softDetails.activityList.length > 0 && (
        <div className={styles.detail_activity}>
          <span className={styles.detail_activity_name}>超值活动：</span>
          {softDetails.activityList.map((item, i) => (
            <span
              className={styles.detail_activity_item}
              onClick={() => {
                onDetailsActivity(item);
              }}
              key={i}
            >
              <span className={styles.detail_activity_text}>{item.activityDesc}</span>

              {item.targetType === '5' && (
                <>
                  <span className={styles.detail_activity_buy}>立即购买</span>
                  <span className={`iconfont icon-point_right ${styles.detail_activity_point}`} />
                </>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
});
